import mountApp         from 'cfg/mountApp';
import TrafficInventory from './Vue/TrafficInventory.vue';


export default (selector, options = {}) => {
  const vueOptions = {
    translationDomain: 'traffic_inventory',
    components: { TrafficInventory },
    data() {
      return { };
    },
  };

  return mountApp({...options, ...vueOptions}, selector);
};
